import { useState } from 'react';

import { observer } from 'mobx-react-lite';

import Button from 'components/common/Button/Button';
import RoleList from 'components/roles/RoleManagement/RoleList/RoleList';
import RoleFormDialog from 'components/roles/RoleManagement/RoleFormDialog/RoleFormDialog';

import DeleteRoleDialog from './RoleFormDialog/DeleteRoleDialog';
import { RoleDialogType } from '../roles.enums';
import { RoleDto } from '../roles.dto';
import styles from './RoleManagement.module.scss';

const RoleManagement = () => {
  const [dialogType, setDialogType] = useState<RoleDialogType>(RoleDialogType.None);
  const [currentRole, setCurrentRole] = useState<RoleDto | undefined>(undefined);

  const openDialog = (newDialogType: RoleDialogType, role: RoleDto) => {
    setCurrentRole(role);
    setDialogType(newDialogType);
  };

  const closeDialog = () => {
    setDialogType(RoleDialogType.None);
  };

  return (
    <div className={styles.rolePage}>
      <div className={styles.infoContainer}>
        <div className={styles.headerTitle}>Role Management</div>
        <div>
          {/*<Button onClick={() => setDialogType(RoleDialogType.Add)} className={styles.button}>*/}
          {/*  + Add Role*/}
          {/*</Button>*/}

          {/*<RoleFormDialog*/}
          {/*  isOpen={dialogType === RoleDialogType.Add}*/}
          {/*  onClose={closeDialog}*/}
          {/*  title="Role Setup"*/}
          {/*  dialogType={dialogType}*/}
          {/*/>*/}

          <RoleFormDialog
            isOpen={dialogType === RoleDialogType.Edit}
            onClose={closeDialog}
            title="Edit Role"
            initial={currentRole}
            dialogType={dialogType}
          />

          <RoleFormDialog
            isOpen={dialogType === RoleDialogType.View}
            onClose={closeDialog}
            title="Role View"
            initial={currentRole}
            dialogType={dialogType}
          />

          <DeleteRoleDialog
            isOpen={dialogType === RoleDialogType.Delete}
            currentRole={currentRole}
            onClose={closeDialog}
          />
        </div>
      </div>

      <div className={styles.tableContainer}>
        <RoleList onOpenDialog={openDialog} />
      </div>
    </div>
  );
};

export default observer(RoleManagement);
